<div class="container">
    <mat-accordion>
        <mat-expansion-panel style="background-color: rgb(23, 24, 36);" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="display: flex;">
                    <h1 style="color: white; padding-top: 10px;">{{exam_name}}</h1>
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <p>Completa el cuestionario seleccionando una de las respuestas para cada pregunta.
                Para navegar entre exámenes primero presiona el botón guardar en la parte inferior derecha, así, tus
                respuestas serán temporalmente guardadas.</p>
            <p>
                Antes de enviar las respuestas, verifica que todas las preguntas cuenten con una respuesta. Al
                finalizar,
                presiona el boton enviar, que se encuentra en el panel lateral izquierdo, para que tus resultados queden
                correctamente registrados.
            </p>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="card" *ngFor="let question of questions let i = index">
        <mat-card>
            <mat-card-header>
                <mat-card-title>{{i+1}}.- {{question.question}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-radio-group [(ngModel)]="question.selected" class="example-radio-group">
                    <img [src]="images+question.question_image" alt="">


                    <div *ngIf="question.question_type_id==4">
                        <div *ngFor="let answer1 of question.questionsSet let j = index">
                            <div class="column-relation">
                                <div class="right-question">
                                    <p>
                                        <span style="font-weight: 500; font-size: large;">{{answer1.answer_if_text}} .-</span>
                                        {{answer1.answer}}

                                    </p>
                                </div>
                                <div class="left-question">
                                    <input type="text" [(ngModel)]="question.answersSet[j].answer">
                                    <img style="height: 50px;width: 50px;"
                                        [src]="images+question.answersSet[j].answer_image" alt="">
                                </div>
                                <br>
                            </div>
                        </div>
                    </div>

                    <div *ngFor="let answer of question.answers let j = index">
                        <div *ngIf="question.question_type_id==1">
                            <img [src]="images+answer.answer_image" alt="">
                            <mat-radio-button [value]="[answer.answer_id]" class="example-radio-button">
                                <div class="wrap-mat-radio-label">{{answer.answer}}</div>
                            </mat-radio-button>
                        </div>
                        <div *ngIf="question.question_type_id==2">
                            <p>
                                <mat-checkbox [(ngModel)]="answer.selected">{{answer.answer}}</mat-checkbox>
                            </p>
                        </div>
                        <div *ngIf="question.question_type_id==5">
                           <p> <input type="text" [(ngModel)]="answer.selected">
                            {{answer.answer}}</p>

                        </div>
                    </div>
                </mat-radio-group>
            </mat-card-content>
        </mat-card>
    </div>
    <br><br><br>
    <button class="savebutton" mat-fab color="accent" (click)="saveExam()">
        <mat-icon>save</mat-icon>
    </button>
</div>